import { getStudioClock } from "@/lib/utils/date/studio-clock";
import {
  getScheduleEntryWallClock,
  type ScheduleInstantSlot,
} from "./scheduleSlotDisplay";

export type { ScheduleInstantSlot };

/**
 * True when the slot has not ended yet (same rule as teacher availability:
 * compare end time on today's sessions, full days for future dates).
 */
export function isUpcomingScheduleSlot(
  entry: ScheduleInstantSlot,
  now: Date = new Date(),
  timeZone?: string | null,
): boolean {
  const wall = getScheduleEntryWallClock(entry);
  if (wall) {
    const clock = getStudioClock(now, timeZone);
    if (wall.dateYmd < clock.ymd) return false;
    if (wall.dateYmd > clock.ymd) return true;

    const [hour, minute] = wall.endTime.split(":").map(Number);
    const endMinutes = hour * 60 + minute;
    return clock.minutesFromMidnight < endMinutes;
  }

  const end = entry.end instanceof Date ? entry.end : new Date(entry.end);
  if (Number.isNaN(end.getTime())) return false;
  return end.getTime() > now.getTime();
}

export function filterUpcomingScheduleSlots<T extends ScheduleInstantSlot>(
  entries: T[],
  now: Date = new Date(),
  timeZone?: string | null,
): T[] {
  return entries.filter((entry) =>
    isUpcomingScheduleSlot(entry, now, timeZone),
  );
}
